export const FETCH_PARTNER_TYPE_URL = `${process.env.REACT_APP_API_URL}/partner_types`;
export const CREATE_PARTNER_TYPE_URL = `${process.env.REACT_APP_API_URL}/partner_types`;
export const UPDATE_PARTNER_TYPE_URL = `${process.env.REACT_APP_API_URL}/partner_types`;
export const DELETE_PARTNER_TYPE_URL = `${process.env.REACT_APP_API_URL}/partner_types`;
